// Rutas que se generan automáticamente
const rutasDeFormularios = [
  { path: "asegurador", name: "Asegurador", component: "Asegurador" },
  { path: "clasdiag", name: "ClasDiag", component: "ClasDiag" },
  { path: "claselem", name: "ClasElem", component: "ClasElem" },
  { path: "diagnostico", name: "Diagnostico", component: "Diagnostico" },
  { path: "elemento", name: "Elemento", component: "Elemento" },
  { path: "especialidad", name: "Especialidad", component: "Especialidad" },
  { path: "estadocivil", name: "EstadoCivil", component: "EstadoCivil" },
  { path: "examen", name: "Examen", component: "Examen" },
  { path: "factura", name: "Factura", component: "Factura" },
  { path: "facturadet", name: "FacturaDet", component: "FacturaDet" },
  { path: "formapago", name: "FormaPago", component: "FormaPago" },
  { path: "localidad", name: "Localidad", component: "Localidad" },
  { path: "medico", name: "Medico", component: "Medico" },
  { path: "pago", name: "Pago", component: "Pago" },
  { path: "perfil", name: "Perfil", component: "Perfil" },
  { path: "persona", name: "Persona", component: "Persona" },
  { path: "plan", name: "Plan", component: "Plan" },
  { path: "sesion", name: "Sesion", component: "Sesion" },
  { path: "suscpago", name: "SuscPago", component: "SuscPago" },
  { path: "suscripcion", name: "Suscripcion", component: "Suscripcion" },
  { path: "tipoelem", name: "TipoElem", component: "TipoElem" },
  { path: "tipoexamen", name: "TipoExamen", component: "TipoExamen" },
  { path: "tipoiden", name: "TipoIden", component: "TipoIden" },
  { path: "usuario", name: "Usuario", component: "Usuario" },
];

// Rutas que necesitan mantenerse independientes debido a los parámetros
const rutasIndependientes = [
  {
    path: "/autorizacion-tramite/:p_idtramite",
    name: "AutorizacionTramite",
    component: "AutorizacionTramite",
  },
  {
    path: "/bitacora-tramite/:p_idtramite",
    name: "BitacoraTra",
    component: "BitacoraTra",
  },
  {
    path: "/cargaplanilla/:p_idtramite/:p_idcarga",
    name: "CargaPlanilla",
    component: "CargaPlanilla",
  },
  {
    path: "/cargaplanillaobs/:p_idtramite/:p_idcarga",
    name: "CargaPlanillaObs",
    component: "CargaPlanillaObs",
  },
  {
    path: "/cargaplanillaerrores/:p_idtramite/:p_idcarga",
    name: "CargaPlanillaErrores",
    component: "CargaPlanillaErrores",
  },
  {
    path: "/cargaplanillanovedades/:p_idtramite/:p_idcarga",
    name: "CargaPlanillaNovedades",
    component: "CargaPlanillaNovedades",
  },
];

// Genera dinámicamente las rutas a partir de las definiciones automáticas
const routes = rutasDeFormularios.map(({ path, name, component }) => ({
  path: `/${path}`,
  name,
  // Importación dinámica para lograr la carga diferida de componentes de ruta
  component: () => import(`../views/forms/${component}.vue`),
}));

// Agrega las rutas que necesitan mantenerse independientes
routes.push(
  ...rutasIndependientes.map(({ path, name, component }) => ({
    path,
    name,
    component: () => import(`../views/forms/${component}.vue`),
  }))
);

export default routes;
